import { render, staticRenderFns } from "./APInquiryHistory.vue?vue&type=template&id=8c0909ce&scoped=true&"
import script from "./APInquiryHistory.vue?vue&type=script&lang=js&"
export * from "./APInquiryHistory.vue?vue&type=script&lang=js&"
import style0 from "./APInquiryHistory.vue?vue&type=style&index=0&id=8c0909ce&lang=less&scoped=true&"
import style1 from "./APInquiryHistory.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0909ce",
  null
  
)

component.options.__file = "APInquiryHistory.vue"
export default component.exports